import React from 'react';
import styles from '../css/reports.module.css';
import { calculateTimeDifference } from '../helpers/timeDifference';
import { useState } from 'react';
import { exportToExcel } from '../helpers/exportToExcel';

function StayDurationRpt({ reportData }) {
  const ITEMS_PER_PAGE = 40;
  const totalPages = Math.ceil(reportData.length / ITEMS_PER_PAGE);

  const [page, setPage] = useState(1);
  const start = (page - 1) * ITEMS_PER_PAGE;
  const end = start + ITEMS_PER_PAGE;
  const paginatedData = reportData.slice(start, end);
  return (
    <div className={styles.paginationContainer}>
      <div className={styles.exportContentContainer}>
        <div className={styles.exportContainer}>
          <button className={styles.reportButton} onClick={() => exportToExcel(reportData, 'ActivityReport')}>
            Export to Excel
          </button>
        </div>
        {reportData.length > 0 && (
          <table className={styles.reportTable}>
            <caption>Stay Duration Report</caption>
            <thead>
              <tr>
                <th>Ticket</th>
                <th>Section</th>
                <th>Lane</th>
                <th>Space</th>
                <th>Date In</th>
                <th>Time In</th>
                <th>Date Out</th>
                <th>Time Out</th>
                <th>Stay Hours</th>
                <th>Stay Minutes</th>
                <th>Stay Duration</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, id) => (
                <tr key={item.id}>
                  <td>{item.Ticket}</td>
                  <td>{item.SectionName}</td>
                  <td>{item.LaneNum}</td>
                  <td>{item.SpaceNum}</td>
                  <td>{new Date(item.CheckIn).toLocaleDateString()}</td>
                  <td>{new Date(item.CheckIn).toLocaleTimeString()}</td>
                  <td>{new Date(item.CheckOutDateTime).toLocaleDateString()}</td>
                  <td>{new Date(item.CheckOutDateTime).toLocaleTimeString()}</td>
                  <td>{item.StayHr}</td>
                  <td>{item.StayMin}</td>
                  <td>
                    {calculateTimeDifference(
                      new Date(item.CheckIn),
                      new Date(item.CheckOutDateTime),
                    ).timeDiff.toString()}
                  </td>
                  {/* <td>
                      {
                        item.StayDuration
                      }
                    </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div>
        <button disabled={page === 1} className={styles.prevButton} onClick={() => setPage(1)}>
          {'<<'}
        </button>
        <button disabled={page === 1} className={styles.prevButton} onClick={() => setPage(page - 1)}>
          {'< Prev'}
        </button>

        <span>
          {' '}
          Page {page} of {totalPages}{' '}
        </span>

        <button disabled={page === totalPages} className={styles.nextButton} onClick={() => setPage(page + 1)}>
          {'Next >'}
        </button>
        <button disabled={page === totalPages} className={styles.nextButton} onClick={() => setPage(totalPages)}>
          {'>>'}
        </button>
      </div>
    </div>
  );
}

export default StayDurationRpt;
